import useStyles from "../styles";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import Button from "../../../components/Button/Button";
const OrganisationDetails = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={4}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <div className="left-container">
          <h4>Organisation Details</h4>
          <h6>Update your personal details here</h6>
        </div>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <div className="right-container">
          <Grid container spacing={2} className={classes.profileform}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="text" label="Organisation Name" name="" />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TextAreaGroup label="Mission" />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TextAreaGroup label="Vision" />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="Total Staff" name="" />
            </Grid>
          </Grid>
          <div className={classes.btnspace}>
            <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" />
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default OrganisationDetails;
